import { createSlice } from "@reduxjs/toolkit";
import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";

const vipVipCommissionState = {
  vipVipCommissionUI: null,
  vipVipCommissionList: null,
  vipVipCommissionEffList: null,
};

export const vipVipCommissionSlice = createSlice({
  name: "vipVipCommission",
  initialState: vipVipCommissionState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.OVERLAY) {
        state.overlayLoading = false;
      }
    },
    throwError: (state, action) => {
      state.error = action.payload.data.error;
    },
    startCall: (state, action) => {
      state.isRefresh = false;
      state.error = null;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.OVERLAY) {
        state.overlayLoading = true;
      }
    },
    clearError: (state) => {
      state.error = null;
    },
    vipVipCommissionUIFetched: (state, action) => {
      state.actionsLoading = false;
      state.vipVipCommissionUI = action.payload.data;
    },
    vipVipCommissionListFetched: (state, action) => {
      state.actionsLoading = false;
      state.vipVipCommissionList = action.payload.data;
    },
    vipVipCommissionEffListFetched: (state, action) => {
      state.actionsLoading = false;
      state.vipVipCommissionEffList = action.payload.data ?? {};
    },
    vipVipCommissionPublished: (state) => {
      state.actionsLoading = false;
    },
  },
});
